// material ui
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';

const StyledGridOverlay = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
});

export default function AlarmsNoRowsOverlay({ rows, isLoading }) {
  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <StyledGridOverlay>
          <Box
            component="svg"
            viewBox="0 0 24 24"
            aria-hidden
            focusable="false"
            sx={{
              width: 96,
              height: 96,
              color: 'success.main',
            }}
          >
            <path
              fill="currentColor"
              d="M9.55 18.2 3.8 12.45l2.1-2.1 3.65 3.65 8.55-8.55 2.1 2.1z"
            />
          </Box>

          <Box sx={{ mt: 2 }}>{rows}</Box>
        </StyledGridOverlay>
      )}
    </>
  );
}
